import Image from "next/image";
import styles from "./WishlistToast.module.scss";
import Button from "@components/atoms/Button";
import Text from "@components/atoms/Text";
import assetLoader from "@utils/internalImageLoder";

interface WishlistToastProps {
  isVisible: boolean;
  isAdding: boolean;
  carMake: string;
  carName: string;
  hasBottomNav: boolean;
  onViewWishlist: () => void;
  onUndo: () => void;
  isInApp?: boolean;
}

const WishlistToast = ({
  isVisible,
  isAdding,
  carMake,
  carName,
  hasBottomNav,
  onViewWishlist,
  onUndo,
  isInApp
}: WishlistToastProps) => {
  if (!isVisible) return null;

  return (
    <div
      className={`${styles.wishlistToast} ${
        hasBottomNav ? styles.hasBottomNav : styles.hasNotBottomNav
      } ${isInApp ? styles.wishlistToatApp : ""}`
      }
    >
      <div className={styles.wishlistToast_iconText}>
        <Image
          src={`${assetLoader()}/icons/greenCheck.webp`}
          alt={isAdding ? "Added to shortlist" : "Removed from shortlist"}
          width={20}
          height={20}
          loading="lazy"
        />
        <Text className={styles.wishlistToast_text}>
          {carMake} {carName} {isAdding ? "shortlisted" : "removed from shortlist"}
        </Text>
      </div>
      {
        isAdding && 
        <Button
          className={styles.wishlistToast_button}
          onButtonClick={onViewWishlist}
          ariaLabel={"View shortlist"}
        >
          View
        </Button>
      }
    </div>
  );
};

export default WishlistToast;
